import { useContext, useEffect, useState } from "react"
import { DataContext } from "../context/DataContext"
import { DivContext } from "../context/DivContext"

const menu_principal = [
  "Contador",
  "Empresario",
  "Productos",
  "Beneficios",
  "Recursos",
  "Registrar",
  "Ingresar",
  "Hablar con un asesor",
]

const classBtnMenu =
  "btnMenu flex justify-between p-5 lg:px-2 text-base font-medium hover:text-gray-900 text-gray-500 focus:outline-none cursor-pointer"
const classBtnSigin =
  "p-5 whitespace-nowrap text-base font-medium text-blue-700 hover:text-blue-500"
const classBtnMobile =
  "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none"

export const useHeader = currentLocation => {
  const dataContext = useContext(DataContext)
  const divContext = useContext(DivContext)
  // divContext.setCurrentLocation(currentLocation)

  const createMarkUp = text => {
    return { __html: text }
  }

  const [menu, setMenu] = useState(0)

  const changeForm = form => {
    dataContext.setStep(form)
  }

  const initialActive = {}

  menu_principal.map((item, i) => (initialActive[i] ??= ""))

  const [classActive, setClassActive] = useState(initialActive)

  const handleActive = index => {
    let arrayClass = initialActive
    let stateClass = classActive[index] === "" ? "active" : ""
    arrayClass = { ...arrayClass, [index]: stateClass }
    setClassActive({ ...arrayClass })
  }

  useEffect(() => {
    if (currentLocation !== undefined && currentLocation.includes("registro")) {
      setMenu(1)
    } else {
      setMenu(0)
    }
    //divContext.setCurrentLocation(currentLocation)
  }, [currentLocation])

  return {
    divContext,
    dataContext,
    menu,
    changeForm,
    classActive,
    handleActive,
    classBtnMenu,
    classBtnSigin,
    classBtnMobile,
    menu_principal,
    createMarkUp,
  }
}
